import { createRoutine } from 'redux-saga-routines';

export const setVOD = createRoutine('SET_VOD');
export const loadVodLink = createRoutine('LOAD_VOD_LINK');
export const downloadVod = createRoutine('DOWNLOAD_VOD');
export const clipVodRoutine = createRoutine('CLIP_VOD');

